"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

// Copyright © 2020 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var DownlinkQueue = /*#__PURE__*/function () {
  function DownlinkQueue(api, _ref) {
    var stackConfig = _ref.stackConfig;
    (0, _classCallCheck2["default"])(this, DownlinkQueue);
    this._api = api;
    this._stackConfig = stackConfig;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(DownlinkQueue, [{
    key: "list",
    value: function () {
      var _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(applicationId, deviceId) {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.DownlinkQueueList({
                  routeParams: {
                    'application_ids.application_id': applicationId,
                    device_id: deviceId
                  }
                });

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadListResponse('downlinks', result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function list(_x, _x2) {
        return _list.apply(this, arguments);
      }

      return list;
    }()
  }, {
    key: "push",
    value: function () {
      var _push = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(applicationId, deviceId, downlinks) {
        var result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.DownlinkQueuePush({
                  routeParams: {
                    'end_device_ids.application_ids.application_id': applicationId,
                    'end_device_ids.device_id': deviceId
                  }
                }, {
                  downlinks: downlinks
                });

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function push(_x3, _x4, _x5) {
        return _push.apply(this, arguments);
      }

      return push;
    }()
  }, {
    key: "replace",
    value: function () {
      var _replace = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(applicationId, deviceId, downlinks) {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.DownlinkQueueReplace({
                  routeParams: {
                    'end_device_ids.application_ids.application_id': applicationId,
                    'end_device_ids.device_id': deviceId
                  }
                }, {
                  downlinks: downlinks
                });

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function replace(_x6, _x7, _x8) {
        return _replace.apply(this, arguments);
      }

      return replace;
    }()
  }]);
  return DownlinkQueue;
}();

var _default = DownlinkQueue;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZXJ2aWNlL2Rvd25saW5rLXF1ZXVlLmpzIl0sIm5hbWVzIjpbIkRvd25saW5rUXVldWUiLCJhcGkiLCJzdGFja0NvbmZpZyIsIl9hcGkiLCJfc3RhY2tDb25maWciLCJhcHBsaWNhdGlvbklkIiwiZGV2aWNlSWQiLCJEb3dubGlua1F1ZXVlTGlzdCIsInJvdXRlUGFyYW1zIiwiZGV2aWNlX2lkIiwicmVzdWx0IiwiTWFyc2hhbGVyIiwicGF5bG9hZExpc3RSZXNwb25zZSIsImRvd25saW5rcyIsIkRvd25saW5rUXVldWVQdXNoIiwicGF5bG9hZFNpbmdsZVJlc3BvbnNlIiwiRG93bmxpbmtRdWV1ZVJlcGxhY2UiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBY0E7O0FBRUE7O0FBaEJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0lBTU1BLGE7QUFDSix5QkFBWUMsR0FBWixRQUFrQztBQUFBLFFBQWZDLFdBQWUsUUFBZkEsV0FBZTtBQUFBO0FBQ2hDLFNBQUtDLElBQUwsR0FBWUYsR0FBWjtBQUNBLFNBQUtHLFlBQUwsR0FBb0JGLFdBQXBCO0FBQ0EsOEJBQVMsSUFBVDtBQUNEOzs7OztnR0FFRCxpQkFBV0csYUFBWCxFQUEwQkMsUUFBMUI7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSx1QkFDdUIsS0FBS0gsSUFBTCxDQUFVSSxpQkFBVixDQUE0QjtBQUMvQ0Msa0JBQUFBLFdBQVcsRUFBRTtBQUNYLHNEQUFrQ0gsYUFEdkI7QUFFWEksb0JBQUFBLFNBQVMsRUFBRUg7QUFGQTtBQURrQyxpQkFBNUIsQ0FEdkI7O0FBQUE7QUFDUUksZ0JBQUFBLE1BRFI7QUFBQSxpREFRU0Msc0JBQVVDLG1CQUFWLENBQThCLFdBQTlCLEVBQTJDRixNQUEzQyxDQVJUOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLE87Ozs7Ozs7Ozs7O2dHQVdBLGtCQUFXTCxhQUFYLEVBQTBCQyxRQUExQixFQUFvQ08sU0FBcEM7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSx1QkFDdUIsS0FBS1YsSUFBTCxDQUFVVyxpQkFBVixDQUNuQjtBQUNFTixrQkFBQUEsV0FBVyxFQUFFO0FBQ1gscUVBQWlESCxhQUR0QztBQUVYLGdEQUE0QkM7QUFGakI7QUFEZixpQkFEbUIsRUFPbkI7QUFDRU8sa0JBQUFBLFNBQVMsRUFBVEE7QUFERixpQkFQbUIsQ0FEdkI7O0FBQUE7QUFDUUgsZ0JBQUFBLE1BRFI7QUFBQSxrREFhU0Msc0JBQVVJLHFCQUFWLENBQWdDTCxNQUFoQyxDQWJUOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLE87Ozs7Ozs7Ozs7O21HQWdCQSxrQkFBY0wsYUFBZCxFQUE2QkMsUUFBN0IsRUFBdUNPLFNBQXZDO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsdUJBQ3VCLEtBQUtWLElBQUwsQ0FBVWEsb0JBQVYsQ0FDbkI7QUFDRVIsa0JBQUFBLFdBQVcsRUFBRTtBQUNYLHFFQUFpREgsYUFEdEM7QUFFWCxnREFBNEJDO0FBRmpCO0FBRGYsaUJBRG1CLEVBT25CO0FBQ0VPLGtCQUFBQSxTQUFTLEVBQVRBO0FBREYsaUJBUG1CLENBRHZCOztBQUFBO0FBQ1FILGdCQUFBQSxNQURSO0FBQUEsa0RBYVNDLHNCQUFVSSxxQkFBVixDQUFnQ0wsTUFBaEMsQ0FiVDs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSxPOzs7Ozs7Ozs7Ozs7ZUFpQmFWLGEiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBDb3B5cmlnaHQgwqkgMjAyMCBUaGUgVGhpbmdzIE5ldHdvcmsgRm91bmRhdGlvbiwgVGhlIFRoaW5ncyBJbmR1c3RyaWVzIEIuVi5cbi8vXG4vLyBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wICh0aGUgXCJMaWNlbnNlXCIpO1xuLy8geW91IG1heSBub3QgdXNlIHRoaXMgZmlsZSBleGNlcHQgaW4gY29tcGxpYW5jZSB3aXRoIHRoZSBMaWNlbnNlLlxuLy8gWW91IG1heSBvYnRhaW4gYSBjb3B5IG9mIHRoZSBMaWNlbnNlIGF0XG4vL1xuLy8gICAgIGh0dHA6Ly93d3cuYXBhY2hlLm9yZy9saWNlbnNlcy9MSUNFTlNFLTIuMFxuLy9cbi8vIFVubGVzcyByZXF1aXJlZCBieSBhcHBsaWNhYmxlIGxhdyBvciBhZ3JlZWQgdG8gaW4gd3JpdGluZywgc29mdHdhcmVcbi8vIGRpc3RyaWJ1dGVkIHVuZGVyIHRoZSBMaWNlbnNlIGlzIGRpc3RyaWJ1dGVkIG9uIGFuIFwiQVMgSVNcIiBCQVNJUyxcbi8vIFdJVEhPVVQgV0FSUkFOVElFUyBPUiBDT05ESVRJT05TIE9GIEFOWSBLSU5ELCBlaXRoZXIgZXhwcmVzcyBvciBpbXBsaWVkLlxuLy8gU2VlIHRoZSBMaWNlbnNlIGZvciB0aGUgc3BlY2lmaWMgbGFuZ3VhZ2UgZ292ZXJuaW5nIHBlcm1pc3Npb25zIGFuZFxuLy8gbGltaXRhdGlvbnMgdW5kZXIgdGhlIExpY2Vuc2UuXG5cbmltcG9ydCBhdXRvQmluZCBmcm9tICdhdXRvLWJpbmQnXG5cbmltcG9ydCBNYXJzaGFsZXIgZnJvbSAnLi4vdXRpbC9tYXJzaGFsZXInXG5cbmNsYXNzIERvd25saW5rUXVldWUge1xuICBjb25zdHJ1Y3RvcihhcGksIHsgc3RhY2tDb25maWcgfSkge1xuICAgIHRoaXMuX2FwaSA9IGFwaVxuICAgIHRoaXMuX3N0YWNrQ29uZmlnID0gc3RhY2tDb25maWdcbiAgICBhdXRvQmluZCh0aGlzKVxuICB9XG5cbiAgYXN5bmMgbGlzdChhcHBsaWNhdGlvbklkLCBkZXZpY2VJZCkge1xuICAgIGNvbnN0IHJlc3VsdCA9IGF3YWl0IHRoaXMuX2FwaS5Eb3dubGlua1F1ZXVlTGlzdCh7XG4gICAgICByb3V0ZVBhcmFtczoge1xuICAgICAgICAnYXBwbGljYXRpb25faWRzLmFwcGxpY2F0aW9uX2lkJzogYXBwbGljYXRpb25JZCxcbiAgICAgICAgZGV2aWNlX2lkOiBkZXZpY2VJZCxcbiAgICAgIH0sXG4gICAgfSlcblxuICAgIHJldHVybiBNYXJzaGFsZXIucGF5bG9hZExpc3RSZXNwb25zZSgnZG93bmxpbmtzJywgcmVzdWx0KVxuICB9XG5cbiAgYXN5bmMgcHVzaChhcHBsaWNhdGlvbklkLCBkZXZpY2VJZCwgZG93bmxpbmtzKSB7XG4gICAgY29uc3QgcmVzdWx0ID0gYXdhaXQgdGhpcy5fYXBpLkRvd25saW5rUXVldWVQdXNoKFxuICAgICAge1xuICAgICAgICByb3V0ZVBhcmFtczoge1xuICAgICAgICAgICdlbmRfZGV2aWNlX2lkcy5hcHBsaWNhdGlvbl9pZHMuYXBwbGljYXRpb25faWQnOiBhcHBsaWNhdGlvbklkLFxuICAgICAgICAgICdlbmRfZGV2aWNlX2lkcy5kZXZpY2VfaWQnOiBkZXZpY2VJZCxcbiAgICAgICAgfSxcbiAgICAgIH0sXG4gICAgICB7XG4gICAgICAgIGRvd25saW5rcyxcbiAgICAgIH0sXG4gICAgKVxuXG4gICAgcmV0dXJuIE1hcnNoYWxlci5wYXlsb2FkU2luZ2xlUmVzcG9uc2UocmVzdWx0KVxuICB9XG5cbiAgYXN5bmMgcmVwbGFjZShhcHBsaWNhdGlvbklkLCBkZXZpY2VJZCwgZG93bmxpbmtzKSB7XG4gICAgY29uc3QgcmVzdWx0ID0gYXdhaXQgdGhpcy5fYXBpLkRvd25saW5rUXVldWVSZXBsYWNlKFxuICAgICAge1xuICAgICAgICByb3V0ZVBhcmFtczoge1xuICAgICAgICAgICdlbmRfZGV2aWNlX2lkcy5hcHBsaWNhdGlvbl9pZHMuYXBwbGljYXRpb25faWQnOiBhcHBsaWNhdGlvbklkLFxuICAgICAgICAgICdlbmRfZGV2aWNlX2lkcy5kZXZpY2VfaWQnOiBkZXZpY2VJZCxcbiAgICAgICAgfSxcbiAgICAgIH0sXG4gICAgICB7XG4gICAgICAgIGRvd25saW5rcyxcbiAgICAgIH0sXG4gICAgKVxuXG4gICAgcmV0dXJuIE1hcnNoYWxlci5wYXlsb2FkU2luZ2xlUmVzcG9uc2UocmVzdWx0KVxuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IERvd25saW5rUXVldWVcbiJdfQ==